import React, { useEffect, useState, useRef } from "react";
import BlackHeader from "../Layout/BlackHeader/BlackHeader";
import styles from "./Disclaimer.module.scss";
import Footer from "../Layout/Footer/Footer";
import useLocoScroll from "../../hooks/useLocoScroll";
import useOnScreen from "../../hooks/useOnScreen";
import MetaDecorator from "../Util/MetaDecorator";
export default function Disclaimer() {
	useLocoScroll(true);
	const ref = useRef(null);

	const [reveal, setReveal] = useState(false);
	const onScreen = useOnScreen(ref);

	useEffect(() => {
		if (onScreen) setReveal(onScreen);
	}, [onScreen]);
	return (
		<>
			<MetaDecorator
				title={"LRC Group | Whistleblowing Policy"}
				description={
					"We are very delighted that you have shown interest in our enterprise. Data protection is of a particularly high priority for the management of the LRC Group. The use of the Internet pages of the LRC Group is possible without any indication of personal data; however, if a data subject wants to use special enterprise services via our website, processing of personal data could become necessary."
				}
			/>
			<div className="sticky-header">
				<BlackHeader />
			</div>
			<div
				id="main-container"
				data-scroll-container>
				<section
					className={styles.DisclaimerAlignment}
					data-scroll-section>
					<div className="container">
						<div className={styles.boxCenterAlignment}>
							<div className={styles.boxWidth}>
								<div className={styles.pageTitle}>
									<h1>Whistleblowing Policy</h1>
								</div>
								<div className={styles.subTextAlignment}>
									<h2>
										Whistleblowing Policy for employees and other third parties
									</h2>
									<p>
										Employees and other individuals working with or on behalf of
										the LRC Group may, in properly carrying out their duties,
										have access to, or come into contact with, information of a
										confidential nature. Their terms and conditions provide that
										except in the proper performance of their duties, employees
										are forbidden from disclosing, or making use of in any form
										whatsoever, such confidential information. However, the law
										allows employees to make a ‘protected disclosure’ of certain
										information. In order to be ‘protected’, a disclosure must
										relate to a specific subject matter and the disclosure must
										also be made in an appropriate way. Whistleblowing
										protection is confined to a disclosure which, in the
										reasonable belief of the employee making the disclosure, is
										made in the public interest.
									</p>
									<p>
										The LRC Group is committed to compliance with the relevant
										legislation in all jurisdictions within which it operates.
									</p>
									<ul>
										<li>
											Ireland; Protected Disclosures Act 2014, as amended by
											Protected Disclosures (Amendment) Bill 2021 and the
											Protected Disclosures (Amendment) Act 2022
										</li>
										<li>UK; Public Interest Disclosure Act 1998 (PIDA)</li>
										<li>Malta; Protection of the Whistleblower Act, 2013</li>
										<li>
											Cyprus; The Protection of people reporting infringement of
											European and National Laws Law - Ν.6(Ι)/2022
										</li>
										<li>
											Luxembourg; Law of 30 July 2019 on the Protection of
											Whistleblowers
										</li>
										<li>
											Germany; Law of June 2023, the Hinweisgeberschutzgesetz
											(WhistleBlower Protection Act)
										</li>
										<li>
											Poland; As of January 2025, Poland has implemented the
											Whistleblower Protection Act, which came into force on 25
											September 2024.
										</li>
									</ul>
									<p>
										<em>
											In order to guarantee a EU-wide standard for the
											protection of whistleblowers, the European Union adopted a
											regulation for whistleblower protection in December 2019.
											In a two-year implementation period EU member states will
											be obliged to implement the directive into their own
											national laws up to 2021.
										</em>
									</p>
									<p>
										The Group actively encourages a culture of honesty and
										openness and therefore all employees and other relevant
										stakeholders (such as contractors, consultants, interns and
										suppliers) are required to bring up to their line manager or
										other designated person any issue that, in the employee’s
										opinion, might constitute bribery or corruption.
									</p>

									<h2>Aims of the Whistleblowing policy</h2>
									<p>Our arrangements aim to;</p>
									<ul>
										<li>
											Provide secure ways for employees and others who work with
											or on behalf of the LRC Group (such as contractors,
											consultants, suppliers and former workers) to raise
											concerns and, where appropriate, to receive feedback on
											any action taken
										</li>
										<li>
											Provide reassurance that every effort will be made to
											protect anyone who makes a report from being victimised
										</li>
									</ul>
									<p>
										There are procedures in place which allow employees and
										people who work for the LRC Group to lodge a grievance
										relating to their own employment, for example, bullying and
										harassment. Whistleblowing relates to concerns about
										wrongdoing that affect others (e.g. the public, company
										integrity, or legal violations), while grievances typically
										concern personal employment matters.{" "}
										<b>
											<i>These are covered in the employee handbook.</i>
										</b>{" "}
										Whistleblowing is intended to cover concerns that fall
										outside the range of these procedures.
									</p>
									<h2>Principles</h2>
									<ul>
										<li>
											All concerns raised will be treated fairly and properly
										</li>
										<li>
											We will not tolerate the harassment or victimisation of
											anyone raising a genuine concern
										</li>
										<li>
											Any individual making a disclosure will retain their
											anonymity unless they agree otherwise
										</li>
										<li>
											We will ensure that any individual raising a concern is
											aware of who is handling the matter
										</li>
										<li>
											We will ensure no one will be at risk of suffering some
											form of retribution as a result of raising a concern even
											if they are mistaken. We do not however extend this
											assurance to someone who maliciously raises a matter they
											know to be untrue.
										</li>
									</ul>
									<p>
										Whistle-blowers are protected by legislation (in certain
										jurisdictions) if they whistle blow appropriately. For
										employees based in jurisdictions where there is no explicit
										whistleblowing protections the LRC Group will treat them as
										if they were based in a jurisdiction which does provide such
										protections.
									</p>
									<ul>
										<li>
											Whistle-blowers are protected if they reasonably believe
											the information disclosed tends to show that one of the
											following has happened, is happening, or is likely to
											happen;
											<ul style={{ listStyleType: "circle" }}>
												<li>Unlawful activity</li>
												<li>
													Financial fraud (for example accounting manipulation,
													non-compliance with internal controls procedures,
													misappropriation of assets or fraudulent statements)
												</li>
												<li>
													Bribery or corruption (for example conflicts of
													interest, bribery, sponsorships & donations, gifts or
													facilitation payments)
												</li>
												<li>
													Violation of competition laws (for example price
													fixing, exchange of price sensitive information,
													collusion with competitors)
												</li>
												<li>
													Serious endangerment to environment, health and safety
												</li>
												<li>
													Activities, which otherwise by law, treaty or
													agreement amount to serious improper conduct (for
													example discriminatory practises, use of child labour,
													human rights violations)
												</li>
											</ul>
										</li>
										<li>Make the disclosure in the public interest</li>
										<li>Reasonably believes the information is true</li>
										<li>
											Believe the whistleblowing is being made to the right
											person
										</li>
									</ul>
									<h2>Whistleblowing</h2>
									<p>
										All cases of actual or suspected fraud, corruption, bribery
										and theft must be reported immediately;
									</p>
									<ul>
										<li>
											Information which an employee reasonably believes tends to
											show one or more of the above should promptly be disclosed
											to{" "}
											<u>
												<b>his/her line manager</b>
											</u>{" "}
											so that any appropriate action can be taken.
										</li>
										<li>
											If it is inappropriate to make such a disclosure to their
											line manager, the employee should speak to{" "}
											<u>
												<b>
													next highest or another level of management, including
													to the COO or the CEO.
												</b>
											</u>{" "}
										</li>
										<li>
											Individuals who make a disclosure under this policy will
											suffer no detriment of any sort for making such a
											disclosure in accordance with this procedure.
										</li>
										<li>
											However, failure to follow this procedure may result in
											the disclosure of information losing its ‘protected
											status.’{" "}
										</li>
										<li>
											For further guidance in relation to this matter or
											concerning the use of the disclosure procedure generally,
											individuals should speak in confidence to
											<u>
												<b>Head of Compliance.</b>
											</u>{" "}
										</li>
										<li>
											A Whistle-blower who knowingly makes a false report may be
											subject to appropriate action, in line with applicable
											procedures.
										</li>
										<li>
											Anyone who retaliates against a Whistle-blower (who
											reported an event in good faith) may be subject to
											disciplinary or contractual consequences, in line with
											relevant procedures.
										</li>
										<li>
											Crimes against a person or property, such as assault,
											rape, burglary, etc., should immediately be reported to
											local law enforcement personnel.
										</li>
										<li>
											Managers and/or Directors who receive the reports must
											promptly act to investigate and/or resolve the issue.
										</li>
										<li>
											If the investigation of a report, that was done in good
											faith and investigated by internal personnel, is not to
											the Whistle-blower’s satisfaction, then he/she has the
											right to report the event to the appropriate legal or
											investigative agency.
										</li>
										<li>
											The identity of the Whistle-blower, if known, shall remain
											confidential to those persons directly involved in
											applying this policy, unless the issue requires
											investigation by law enforcement, in which case members of
											the organisation are subject to subpoena.
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</section>
				<>
					<Footer />
				</>
				<div className="footerBottomAlignment"></div>
			</div>
		</>
	);
}
